import { render, staticRenderFns } from "./zipUploadButton.vue?vue&type=template&id=23a34ee2&"
import script from "./zipUploadButton.vue?vue&type=script&lang=js&"
export * from "./zipUploadButton.vue?vue&type=script&lang=js&"
import style0 from "./zipUploadButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports